import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductsShowcase from './components/ProductsShowcase';
import Features from './components/Features';
import AICapabilities from './components/AICapabilities';
import DashboardPreviews from './components/DashboardPreviews';
import IndustryVerticals from './components/IndustryVerticals';
import ArchitectureVisualizer from './components/ArchitectureVisualizer';
import ProcessTimeline from './components/ProcessTimeline';
import CaseStudy from './components/CaseStudy';
import TrustCredentials from './components/TrustCredentials';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-blue-500 selection:text-white">
      <Header />
      <main>
        <Hero />
        <ProductsShowcase />
        <Features />
        <AICapabilities />
        <DashboardPreviews />
        <IndustryVerticals />
        <ArchitectureVisualizer />
        <ProcessTimeline />
        <CaseStudy />
        <TrustCredentials />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
